import React from 'react';

import { TAttachmentId } from '@entities/attachment/model/types';
import { Icon } from '@shared/ui';
import { TMenuItem } from '@shared/ui/MenuList/model/types';

interface IGetAttachmentMenuParams {
    fileId: TAttachmentId;
    handleDownload: (id: TAttachmentId) => void;
    handleDelete: (id: TAttachmentId) => void;
}

// @ts-ignore
export const getAttachmentMenu = ({
    fileId,
    handleDownload,
    handleDelete,
}: IGetAttachmentMenuParams): TMenuItem[] => [
    {
        id: 'download',
        IconLeft: React.createElement(Icon, {
            iconName: 'download',
            width: 16,
            height: 16,
        }),
        // @ts-ignore
        name: i18next.t('button.download.text'),
        onClick: () => handleDownload(fileId),
    },
    {
        id: 'delete',
        IconLeft: React.createElement(Icon, {
            iconName: 'delete',
            width: 16,
            height: 16,
            fill: 'currentColor',
        }),
        // @ts-ignore
        name: i18next.t('button.delete.text'),
        onClick: () => handleDelete(fileId),
    },
];
